<ion-header><app-navheader [page]="this.isPage()"></app-navheader>
<img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content padding style="background-color: #04c4fc">
	<ion-item lines="none" class="header blue-item">
    <ion-label class="ion-text-center">
      <h1> {{'ACCOUNT.PROFILE_CREATOR.HEADER' | translate}}</h1>
    </ion-label>
	</ion-item>
	<div class="wrapper">
	<ion-item lines="none" class="info blue-item">
    <ion-label class="ion-text-center">
      {{'ACCOUNT.PROFILE_CREATOR.LIMIT' | translate}}
    </ion-label>
	</ion-item>
    <ion-list>
      <form (ngSubmit)="onSubmit(form.value, $event)" #form = "ngForm">
        <div class="profile-wrapper">
          <ion-item lines="none" class="child blue-item">
            <ion-label class="ion-text-center"> {{'ACCOUNT.PROFILE_CREATOR.CHILD' | translate }} </ion-label>
            </ion-item>
            <ion-item lines="none" class="firstinput blue-item">
              <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.PRENOM' | translate}}</ion-label>
              <ion-input [(ngModel)]="model.firstName" name="firstName" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error, 'emailvalidation': !validation && userstatus}" type="text"></ion-input>
            </ion-item>
            <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
            <div class="errortext" [ngClass]= "{'visible': !validation && userstatus}">{{'ERROR.EMAIL.INVALID' | translate}}</div>
            <ion-item lines="none" class="firstinput blue-item">
              <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.NOM' | translate}}</ion-label>
              <ion-input [(ngModel)]="model.lastName" name="lastName"  [ngClass] = "{'ng-invalid': error, 'ng-dirty': error, 'emailvalidation': !validation && userstatus}" type="text"></ion-input>
            </ion-item>
            <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
            <div class="errortext" [ngClass]= "{'visible': !validation && userstatus}">{{'ERROR.EMAIL.INVALID' | translate}}</div>
            <ion-item lines="none" class="abonumber blue-item">
              <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.SUBSCRIPTION_NUMBER' | translate}}</ion-label>
              <ion-input [required] = "!model.coupon" [(ngModel)]="model.subscriber_number" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error, 'emailvalidation': !validation && userstatus}" type = "text" name="subscriber_number"></ion-input>
            </ion-item>
            <div class="qmarkwrapper"><img (click)="presentPopover($event)" class="qmark" src="../../../assets/img/qmark.png" /></div>
            <div class="errortextpassword" [hidden]= "coupon.valid || coupon.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
            <ion-item lines="none" class="abonumber blue-item">
              <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.COUPON' | translate}}</ion-label>
              <ion-input [required] = "!model.subscriber_number" (ionChange) = "changeHandler()" [(ngModel)]="model.coupon" [ngClass] = "{'invalid': error_coupon, 'dirty': error_coupon}" type = "text" name="coupon" #coupon = "ngModel"></ion-input>
            </ion-item>
            <div class="qmarkwrapper"><img (click)="presentPopover2($event)" class="qmark2" src="../../../assets/img/qmark.png" /></div>
            <div class="errortextt" [ngClass]= "{'visible': error_coupon, 'hidden':  coupon.valid}">
              <span>{{ 'ERROR.COUPON.INVALID_CODE' | translate }}</span>
            </div>
            <div class="errortextpassword" [hidden]= "coupon.valid || coupon.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
        </div>
        <ion-button [disabled]="!form.valid" type="submit"  class="createChildrenProfileAction">
          {{'ACCOUNT.PROFILE_CREATOR.BUTTON' | translate}}
        </ion-button>
      </form>
    </ion-list>
	</div>
</ion-content>
<ion-footer><app-bottom-menu></app-bottom-menu></ion-footer>
